export var SCHEDULE_CTA_BY_NAME = {
  buy: 'buy',
  cancel: 'cancel',
  disable: 'disable',
  join: 'join',
  reactivate: 'reactivate',
  reserve: 'reserve',
  signup: 'signup'
};